import { stdObject } from "../../../../data/types/stdObject";

export const finalBalanceFunc = (salesSection: stdObject) => {
  return "header" in salesSection
    ? salesSection.results.previousBalance +
        (salesSection.results.totals?.TOTAL ?? 0) -
        salesSection.results.totals.payTotal
    : 0;
};
